import React from 'react'
import classNames from 'classnames'
import { DescriptionMDSProps } from './DescriptionMDS.d'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import { MicrocopyOptions } from '@toasttab/shared/src/utils/Contentful/richText'

// Component's Render Function with Props
const Description = ({
  tagEl = 'p',
  variation = 'default',
  classes,
  content,
  componentClass
}: DescriptionMDSProps) => {
  const DescriptionElm = tagEl
  const styleClasses = classRules(variation, classes, componentClass)

  return content && content.raw ? (
    <DescriptionElm className={styleClasses} data-testid='mds-description'>
      {renderRichText(content, MicrocopyOptions)}
    </DescriptionElm>
  ) : (
    <DescriptionElm
      data-testid='mds-description'
      className={styleClasses}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}

// Create ClassName Object for Styles
const classRules = (
  variation: string,
  classes?: string,
  componentClass?: string
) =>
  classNames(classes, componentClass, 'items-center', {
    'text-base font-normal leading-normal font-sansPro tracking-normal':
      variation === 'default',
    'text-xs font-normal leading-4 font-sansPro': variation === 'caption',
    'text-xs font-normal leading-4 font-sansPro tracking-widest uppercase':
      variation === 'overline',
    'text-xs font-semibold leading-[14px] font-sansPro tracking-[1.2px] uppercase text-black':
      variation === 'badge'
  })

// Export Render Function
export default Description
